<!-- HTML Template -->
<template>
  <div>
    <div id="page-layout">
      <div id="page-header">
        <div class="page-title-layout">
          <p v-if="isMyFiles()">{{$t("files.my_files_title")}}</p>
          <p v-if="isSharedFiles()">{{$t("files.shared_files_title")}}</p>
        </div>
        <button class="solid-button" type="button" v-on:click="addFile()" v-if="isMyFiles()" :disabled="uploading">
          <i class="fas fa-plus" v-if="!uploading"></i>
          <span v-if="!uploading">{{$t("files.my_files_add")}}</span>
          <spinner :size="24" v-if="uploading"></spinner>
        </button>
      </div>
      <div id="page-content">
        <file-list
          :show-file-status="true"
          :can-download="true"
          :can-rename="isMyFiles()"
          :can-delete="isMyFiles()"
          :files="files"
          @refresh="loadData()">
        </file-list>
      </div>
      <div id="page-footer" v-if="isMyFiles()">
        <form
          novalidate
          enctype="multipart/form-data"
          name="uploadForm">
          <div class="dropbox">
            <input
              ref="upload"
              type="file"
              multiple
              :disabled="uploading"
              @change="onFilesChanged"
              class="input-file">
            <div class="dropbox-content" v-if="!uploading">
              <svg width="31px" height="23px" class="icon-blue">
                <use xlink:href="#upload"></use>
              </svg>
              <p class="default-text" v-html="$t('files.upload')"></p>
            </div>
            <div class="dropbox-content" v-if="uploading">
              <spinner></spinner>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
  import File from "../models/File.js";
  import fileService from "../services/fileService.js";
  import fileList from "../components/fileList.vue";
  import spinner from "../components/spinner.vue";
  import Utils from "../services/utils.js";

  const PageModes = {
    SHARED: 'shared',
    MINE: 'mine'
  };

  export default {
    props: {
      pageMode: {
        type: String,
        default: function () {
          return PageModes.MINE
        }
      },
    },
    watch: {
      '$route'(to) {
        if (to.params.pageMode !== this.pageMode) {
          this.loadData();
        }
      }
    },
    components: {
      fileList,
      spinner
    },
    data() {
      return {
        files: [],
        uploading: false
      };
    },
    methods: {
      isMyFiles() {
        return this.pageMode === PageModes.MINE;
      },
      isSharedFiles() {
        return this.pageMode === PageModes.SHARED;
      },
      loadData() {
        this.files = [];
        const origin = this.isMyFiles() ? File.Origins.mine : File.Origins.shared;
        fileService.getFiles(origin).then(files => {
          this.files = files;
        });
      },
      addFile() {
        this.$refs.upload.click(); // click on input
      },
      uploadFiles(files) {
        let tooBig = false;
        let totalSize = 0;
        for (let x in files) {
          totalSize += ((files[x].size / 1024) / 1024); // MB
          if (totalSize > 200) {
            tooBig = true;
          }
        }
        if (tooBig) {
          this.$store.dispatch('alert/error', {message: this.$t("messages.file_size_limit")});
          return;
        }
        const fileCount = files.length;
        fileService.upload(files)
          .then(() => {
            this.$store.dispatch('alert/success', this.$t("alerts.upload_file_success", {count: fileCount}));
            this.$store.dispatch('file/count');
            this.loadData(); // refresh
            this.uploading = false;
          })
          .catch(error => {
            this.$store.dispatch('alert/error', {
              message: this.$t("alerts.upload_file_error", {count: fileCount}),
              error: error
            });
            this.uploading = false;
          });
        this.uploading = true;
      },
      onFilesChanged(event) {
        const files = event.target.files;
        this.uploadFiles(files);
      }
    },
    mounted() {
      this.uploading = false;
      this.loadData();

      if (Utils.determineDragAndDropCapable()) {
        Utils.disableDragAndDrop(this.$refs.upload);
        this.$refs.upload.addEventListener('drop', function (e) {
          this.uploadFiles(e.dataTransfer.files)
        }.bind(this));
      }
    }
  };
</script>
<style lang="scss" scoped>
  @import '../style/list.scss';

  #page-layout {
    display: grid;
    grid-template-columns: 10% [content] auto 10%;
  }

  #page-header {
    @extend %common-header;
    justify-content: space-between;
  }

  #page-content {
    grid-column-start: content;
    margin-bottom: 70px;
  }

  #page-footer {
    grid-column-start: content;
  }

  .dropbox {
    outline: 2px dashed $bluish-grey; /* the dash box */
    outline-offset: -10px;
    padding: 10px 10px;
    min-height: 200px;
    position: relative;
    cursor: pointer;

    display: grid;
    grid-template-columns: 1fr;
  }

  .dropbox:hover {
    background: $bluish-grey-30;
  }

  .dropbox-content {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
  }

  .input-file {
    opacity: 0; /* hide actual button */
    width: 100%;
    height: 100%;
    position: absolute;
    cursor: pointer;
  }

  .icon-blue {
    color: $blue;
  }
</style>



// WEBPACK FOOTER //
// src/pages/listFiles.vue